import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BellRing } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtWIB, timeLeft } from "@/lib/datetime";
import { REMINDER_POPUP } from "@/constants/testIds";

export const ReminderPopup = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const key = `reminder-popup-${user.id}`;
    if (sessionStorage.getItem(key)) return;
    api.get("/reminders").then(({ data }) => {
      sessionStorage.setItem(key, "1");
      if (data.length) {
        setItems(data);
        setOpen(true);
      }
    }).catch(() => {});
  }, [user.id]);

  const rows = items.flatMap((b) => b.reminders.map((r) => ({ ...r, b })));

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-lg" data-testid={REMINDER_POPUP.dialog}>
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 tracking-tight"><BellRing className="h-5 w-5 text-amber-500" /> Pengingat Booking</DialogTitle>
          <DialogDescription>{rows.length} timelimit perlu ditindaklanjuti.</DialogDescription>
        </DialogHeader>
        <ul className="max-h-80 divide-y divide-slate-100 overflow-y-auto rounded-md border border-slate-200">
          {rows.map((r) => (
            <li key={`${r.b.id}-${r.kind}`} className="flex items-start justify-between gap-3 px-4 py-3" data-testid={REMINDER_POPUP.item}>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-slate-900">{r.b.booking_code} <span className="font-normal text-slate-600">- {r.b.name}</span></p>
                <p className="text-xs text-slate-500">{r.label} · {fmtWIB(r.deadline)}</p>
              </div>
              <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-medium ${r.overdue ? "bg-red-50 text-red-700" : "bg-amber-50 text-amber-700"}`}>{timeLeft(r.deadline)}</span>
            </li>
          ))}
        </ul>
        <DialogFooter>
          <Button variant="outline" className="rounded-full" onClick={() => setOpen(false)} data-testid={REMINDER_POPUP.close}>Nanti</Button>
          <Button className="rounded-full bg-brand hover:bg-brand-dark text-white" onClick={() => { setOpen(false); navigate("/booking"); }} data-testid={REMINDER_POPUP.open}>Lihat Booking</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
